'use client';
import { FunctionComponent, useState } from 'react';
import Company from '@business/general/Company';
import { useAppStateSelector } from '@redux/hooks';
import ALink from '@xFrame4/components/next/ALink';
import { getMenuItemsForLanguage } from 'frontend_business/menus/Menus';
import { useLanguageFromRoute } from '@components/Hooks';
import { tl } from '@xFrame4/common/Utils';
import HeaderLogo from './HeaderLogo';

export interface MobileMenuProps
{
    company: Company;
}

/**
 * Component: menu for mobile
 */
const MobileMenu: FunctionComponent<MobileMenuProps> = () =>
{
    const [isOpen, setIsOpen] = useState(false);
    
    // get the language from the params
    const languageFromRoute = useLanguageFromRoute();
    const language = useAppStateSelector(state => state.layout.language?.code);
    const menuItems = getMenuItemsForLanguage(language ?? languageFromRoute);

    const toggleMenu = () =>
    {
        setIsOpen(!isOpen);
    };

    const closeMenu = () =>
    {
        setIsOpen(false);
    };

    /** Render */
    return (
        <>
            {/* Hamburger Button */}
            <button 
                className="mobile-menu-toggle btn btn-link text-dark p-0"
                onClick={toggleMenu}
                aria-label="Toggle mobile menu"
                aria-expanded={isOpen}
            >
                <i className={`fas fa-${isOpen ? 'times' : 'bars'} font-size-3`}></i>
            </button>

            {/* Mobile Menu Overlay */}
            {isOpen && (
                <div 
                    className="mobile-menu-overlay"
                    onClick={closeMenu}
                />
            )}

            {/* Mobile Menu Drawer */}
            <div className={`mobile-menu-drawer ${isOpen ? 'open' : ''}`}>
                <div className="mobile-menu-header d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
                    <HeaderLogo 
                        language={language ?? languageFromRoute} 
                        className="mobile-menu-header-logo"
                        onClick={closeMenu}
                    />
                    
                    <button 
                        className="btn btn-link text-dark p-0"
                        onClick={closeMenu}
                        aria-label="Close mobile menu"
                    >
                        <i className="fas fa-times fa-lg"></i>
                    </button>
                </div>
                
                <div className="mobile-menu-content">
                    {menuItems.map((item) => (
                        <div key={item.orderNo} className="mobile-menu-item">
                            <ALink 
                                href={item.url}
                                className="d-block px-4 py-3 text-dark text-decoration-none border-bottom"
                                onClick={closeMenu}
                            >
                                {item.name}
                            </ALink>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default MobileMenu;